<template>
  <NuxtLink
    v-slot="props"
    :to="link"
    class="border-inset w-44 cursor-pointer whitespace-nowrap text-center text-sm"
  >
    <WpCard
      class="transition hover:bg-aubergine-100"
      :class="{
        'border-inset rounded-2xl border-2 border-aubergine-dark-500':
          props?.isActive,
      }"
    >
      <div class="slot">
        <slot />
      </div>
    </WpCard>
  </NuxtLink>
</template>

<script lang="ts" setup>
defineProps({
  link: {
    type: String,
    required: true,
  },
})
</script>

<style lang="scss">
.slot {
  @apply p-2;
}
.router-link-exact-active .slot {
  @apply p-[calc(.5rem-2px)];
}
</style>
